import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { SearchItem } from '../search-items/search-items'
import type { CreateStaticAudienceDto } from './create-static-audience.dto'

export class SearchQueryRepository extends BaseRepository<SearchItem> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.prospectApiUrl + '/query', token, cache)
    }

    async getCities() {
        const { json, statusCode, message } = await this.request.get(
            this.config.prospectApiUrl + '/query/cities?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getCategories() {
        const { json, statusCode, message } = await this.request.get(
            this.config.prospectApiUrl + '/query/categories?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async add(dto: CreateStaticAudienceDto) {
        const { json, statusCode, message } = await this.request.post(
            this.config.prospectApiUrl + '/query/add?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
